import React from "react";
import styled from "@emotion/styled";
import three_dots_loading from "../../../assets/lottie/three-dots-loading.json";
import Lottie from "react-lottie";

/*
    props
    size: string        "lg" || null    "lg"(CourseList에서 사용), null(CustomPasswordInput에서 사용)
*/
const ThreeDotsLoading = (props) => {
    // css style
    const {view} = useComponentStyle(props.size);

    return (
        <view.LoadingDots>
            <Lottie
                options={{
                    loop: true,
                    autoPlay: true,
                    animationData: three_dots_loading,
                }}
            />
        </view.LoadingDots>
    );
};

export default ThreeDotsLoading;

export const useComponentStyle = (size) => {
    return {
        view: {
            LoadingDots: styled.div({
                position: size === "lg" ? "" : "absolute",
                width: size === "lg" ? "150px" : "",
                height: size === "lg" ? "30px" : "",
            }),
        },
    };
};
